import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
import { resolveTokenValue } from "../../lib/tokens.js";
import { Fragment, computed, createBlock, createCommentVNode, createElementBlock, createElementVNode, createSlots, createTextVNode, createVNode, mergeProps, normalizeClass, normalizeStyle, openBlock, renderList, renderSlot, resolveComponent, resolveDirective, toDisplayString, unref, withCtx, withDirectives } from "vue";
import { DtButton, DtStack, DtText } from "@dialpad/dialtone-vue";
import { DtIconChevronsUpDown } from "@dialpad/dialtone-icons/vue";
//#region src/components/controls/control_selection.vue
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcControlSelection" }, {
	props: {
		value: {
			type: void 0,
			required: true
		},
		defaultValue: {
			type: void 0,
			default: void 0
		},
		validValues: {
			type: Array,
			default: void 0
		},
		disabled: {
			type: Boolean,
			default: false
		},
		generateLabel: {
			type: Function,
			default: (value) => value.toString()
		},
		tokenCategory: {
			type: String,
			default: void 0
		},
		propValues: {
			type: Object,
			default: void 0
		},
		disabledValues: {
			type: Set,
			default: void 0
		}
	},
	emits: [VALUE_UPDATE_EVENT],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const isColor = (v) => /^(rgb|oklch|#)/.test(v);
		const swatchStyle = (color) => ({
			backgroundColor: color,
			inlineSize: "var(--dt-icon-size-100)",
			blockSize: "var(--dt-icon-size-100)"
		});
		function onInput(e) {
			emit(VALUE_UPDATE_EVENT, e === "null" ? null : e);
		}
		const options = computed(() => {
			const valueOptions = props.validValues?.map((selection) => {
				const optionDisabled = props.disabledValues?.has(String(selection)) ?? false;
				const rawResolved = props.tokenCategory ? resolveTokenValue(props.tokenCategory, selection, props.propValues) : null;
				const resolved = optionDisabled && rawResolved && !isColor(rawResolved) ? null : rawResolved;
				return {
					value: selection,
					label: props.generateLabel(selection),
					resolved,
					disabled: optionDisabled
				};
			}) ?? [];
			if (props.defaultValue === null || props.defaultValue === void 0) return [{
				value: null,
				label: "–"
			}, ...valueOptions];
			return valueOptions;
		});
		const selectedOption = computed(() => {
			return options.value.find((o) => String(o.value) === String(props.value));
		});
		const selectedLabel = computed(() => selectedOption.value?.label ?? "");
		return (_ctx, _cache) => {
			const _component_dt_list_item = resolveComponent("dt-list-item");
			const _component_dt_dropdown = resolveComponent("dt-dropdown");
			const _directive_dt_tooltip = resolveDirective("dt-tooltip");
			return openBlock(), createElementBlock(Fragment, null, [createVNode(unref(DtText), {
				kind: "label",
				size: 100,
				tone: "secondary",
				class: "d-input__label-text d-c-default"
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}), createVNode(_component_dt_dropdown, {
				"navigation-type": "arrow-keys",
				placement: "bottom-start",
				"content-width": "anchor",
				"content-class": "d-hmx-400"
			}, {
				anchor: withCtx(({ attrs }) => [createVNode(unref(DtButton), mergeProps(attrs, {
					importance: "outlined",
					kind: "muted",
					size: 100,
					disabled: __props.disabled,
					class: "d-w100p",
					"label-class": "d-jc-space-between d-fw-normal",
					"leading-class": "d-pis-75"
				}), createSlots({
					endIcon: withCtx(({ iconSize }) => [createVNode(unref(DtIconChevronsUpDown), {
						class: "d-fc-muted",
						size: iconSize
					}, null, 8, ["size"])]),
					default: withCtx(() => [
						createTextVNode(" " + toDisplayString(selectedLabel.value) + " ", 1),
						_cache[0] || (_cache[0] = createElementVNode("span", { "aria-hidden": "true" }, " ", -1)),
						selectedOption.value?.resolved && !isColor(selectedOption.value.resolved) ? withDirectives((openBlock(), createBlock(unref(DtText), {
							key: 0,
							kind: "body",
							size: 100,
							tone: "muted"
						}, {
							default: withCtx(() => [createTextVNode(toDisplayString(selectedOption.value.resolved), 1)]),
							_: 1
						})), [[_directive_dt_tooltip, selectedOption.value.resolved.includes("/") ? "Font Size / Line Height" : void 0]]) : createCommentVNode("", true)
					]),
					_: 2
				}, [selectedOption.value?.resolved && isColor(selectedOption.value.resolved) ? {
					name: "leading",
					fn: withCtx(() => [createElementVNode("span", {
						class: "d-ba d-bc-subtle d-bar-circle",
						style: normalizeStyle(swatchStyle(selectedOption.value.resolved))
					}, null, 4)]),
					key: "0"
				} : void 0]), 1040, ["disabled"])]),
				list: withCtx(({ close }) => [(openBlock(true), createElementBlock(Fragment, null, renderList(options.value, (option) => {
					return openBlock(), createBlock(_component_dt_list_item, {
						key: option.value,
						role: "menuitem",
						"navigation-type": "arrow-keys",
						class: normalizeClass({
							"d-o50 d-pe-none": option.disabled,
							"d-bgc-moderate-opaque": option.value === __props.value
						}),
						"aria-disabled": option.disabled || void 0,
						onClick: ($event) => !option.disabled && (onInput(option.value), close())
					}, {
						default: withCtx(() => [createVNode(unref(DtStack), {
							direction: "row",
							gap: "100",
							align: "baseline",
							class: "d-w100p"
						}, {
							default: withCtx(() => [
								option.resolved && isColor(option.resolved) ? (openBlock(), createElementBlock("span", {
									key: 0,
									class: "d-ba d-bc-subtle d-bar-circle d-as-center",
									style: normalizeStyle(swatchStyle(option.resolved))
								}, null, 4)) : createCommentVNode("", true),
								createElementVNode("span", null, toDisplayString(option.label), 1),
								option.resolved && !isColor(option.resolved) ? (openBlock(), createBlock(unref(DtText), {
									key: 1,
									kind: "body",
									size: 100,
									tone: "muted",
									class: "d-mis-auto"
								}, {
									default: withCtx(() => [createTextVNode(toDisplayString(option.resolved), 1)]),
									_: 2
								}, 1024)) : createCommentVNode("", true)
							]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1032, [
						"class",
						"aria-disabled",
						"onClick"
					]);
				}), 128))]),
				_: 1
			})], 64);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=control_selection.vue.js.map